// Resolve only our own patient storage references. Never send unrelated URLs.
export function privateFileUrls(value) {
  const origin = (process.env.REACT_APP_SUPABASE_URL || '').replace(/\/$/, '');
  if (!origin || value == null) return [];
  const found = new Set();
  const walk = (item) => {
    if (typeof item === 'string') {
      for (const match of item.matchAll(/https?:\/\/[^\s"'<>\\]+/g)) {
        try {
          const url = new URL(match[0]);
          if (url.origin === origin && /^\/storage\/v1\/object\/(public|sign|authenticated)\/(client-files|studio-images)\/(clients|appointments|mobile)\//.test(url.pathname)) found.add(match[0]);
        } catch { /* ordinary text */ }
      }
    } else if (Array.isArray(item)) item.forEach(walk);
    else if (item && Object.getPrototypeOf(item) === Object.prototype) Object.values(item).forEach(walk);
  };
  walk(value);
  return [...found];
}

export function replacePrivateFileUrls(value, resolved) {
  if (typeof value === 'string') return value.replace(/https?:\/\/[^\s"'<>\\]+/g, (url) => resolved[url] || url);
  if (Array.isArray(value)) return value.map(item => replacePrivateFileUrls(item, resolved));
  if (value && Object.getPrototypeOf(value) === Object.prototype) return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, replacePrivateFileUrls(item, resolved)]));
  return value;
}

// Persist stable object references, never expiring bearer tokens in patient notes.
export function canonicalPrivateFileUrls(value) {
  const map = {};
  for (const reference of privateFileUrls(value)) {
    const url = new URL(reference);
    if (url.pathname.includes('/object/sign/')) {
      url.pathname = url.pathname.replace('/object/sign/', '/object/public/');
      url.search = '';
      map[reference] = url.toString();
    }
  }
  return Object.keys(map).length ? replacePrivateFileUrls(value, map) : value;
}
